import type { GiftPassBundleTag } from '@bonsai/shared';

import { GiftPassTag } from './GiftPassTag';

import './gift-pass-tag.css';

export function GiftPassTagList({ tags }: { tags: readonly GiftPassBundleTag[] }) {
  if (tags.length === 0) {
    return (
      <span style={{ color: 'var(--nb-faint)' }}>
        <span aria-hidden="true">—</span>
        <span className="nb-sr-only">No tags</span>
      </span>
    );
  }
  return (
    <ul className="gp-tag-list" aria-label="Tags">
      {tags.map((tag, i) => (
        <li key={i}>
          <GiftPassTag tag={tag} />
        </li>
      ))}
    </ul>
  );
}
